import { Component, computed, forwardRef, input, output, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QMBlockDirective } from '../../../directives/quantum-metric.directive';

@Component({
  selector: 'app-text-area',
  standalone: true,
  imports: [FormsModule, QMBlockDirective],
  templateUrl: './text-area.component.html',
  styleUrl: './text-area.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextAreaComponent),
    },
  ],
})
export class TextAreaComponent implements ControlValueAccessor {
  dataLabel = input<string>();
  placeHolder = input('Please add a description');
  showCount = input<boolean>(true);
  dataTestId = input<string | undefined>();
  hasError = input<boolean>(false);

  rows = input(5);

  maxCharCount = input(200);
  disabled = input(false);
  formDisabled = signal(false);

  showKeyboardFocus = false;
  private isUsingKeyboard = false;
  inputFocused = output<void>();

  constructor() {
    if (typeof document !== 'undefined') {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
          this.isUsingKeyboard = true;
        }
      });

      document.addEventListener('mousedown', () => {
        this.isUsingKeyboard = false;
      });
    }
  }

  private viewModel = computed(() => {
    return {
      placeHolder: this.placeHolder(),
      rows: this.rows(),
      maxCharCount: this.maxCharCount(),
      dataTestId: this.dataTestId(),
      dataLabel: this.dataLabel(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  touched = false;

  value: string | undefined;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange: (value: any) => void = (value: any) => {};

  onTouched = () => {};

  writeValue(value: any) {
    this.value = value;
    this.onChange!(this.value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.formDisabled.set(disabled);
  }

  textInput(newValue: string, textArea: HTMLTextAreaElement): void {
    newValue = newValue.substring(0, this.vm.maxCharCount);
    textArea.value = newValue;
    this.writeValue(newValue);
  }

  onInputFocus() {
    this.showKeyboardFocus = this.isUsingKeyboard;
    this.inputFocused.emit();
  }

  onInputBlur() {
    this.showKeyboardFocus = false;
  }
}
